export default __webpack_public_path__ + "static/media/09.28183dd9.webp";